import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import Bg from '../Components/background/Bg';
import UserKnowledgeLoader from '../Components/Loaders/UserknowledgeLoader';
import ThemeChanger from '../Components/ThemeChanger';

export default function UserKnowledgePage() {
    const [ratings, setRatings] = useState({});
    const { roadMapId } = useParams();
    const [topic, setTopic] = useState('');
    const [subtopic, setSubTopic] = useState('');
    const [modules, setModules] = useState([]);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!roadMapId) return;
        setIsLoading(true);
        api.get(`/user/get-roadmap-header?roadMapId=${roadMapId}`)
            .then((res) => {
              const response = res.data.data;
              if (res.data.statusCode === 200) {
                setTopic(response.topic);
                setSubTopic(response.subTopic);
                api.get(
                  `/user/get-modules?subTopicId=${response.subTopicId}`
                ).then((res) => {
                  const response = res.data.data;
                  setModules(response);
                });
              } else {
                navigate("/dashboard")
              }
                
            })
            .finally(() => {
                setTimeout(() => {
                    setIsLoading(false);
                }, 500);
            });
    }, [roadMapId]);

    const handleStarClick = (moduleName, rating) => {
        setRatings((prev) => ({
            ...prev,
            [moduleName]: rating,
        }));
    };

    const handleStartQuiz = () => {
        const formatedRatings = Object.keys(ratings).map((key) => {
            return {
                name: key.toLowerCase(),
                rating: ratings[key],
            };
        });
        api.post('/user/add-userknowledge', {
            roadMapId: roadMapId,
            userKnowledge: formatedRatings,
        }).then((res) => {
            const response = res.data;
            if (response.statusCode == 200) {
                navigate(`/quiz/${roadMapId}`);
            }
        });
    };

    const handleReturnToDashboard = () => {
        navigate('/dashboard');
    };

    // Check if all modules have been rated
    const allModulesRated = modules.every((module) => ratings[module]);

    return (
        <div className="min-h-screen relative">
            <Bg />

            {isLoading && <UserKnowledgeLoader />}

            {!isLoading && (
                <div className="relative z-10 min-h-screen">
                    <div className="container mx-auto px-4 py-10 max-w-3xl">
                        <div className="flex flex-col lg:flex-row w-full mb-6">
                            <div className="flex flex-col lg:w-1/2 w-full">
                                <h1 className="text-3xl font-bold text-center lg:text-left mb-6 text-primary">
                                    {topic}
                                </h1>
                                <h2 className="text-xl font-medium text-center lg:text-left mb-8 text-secondary">
                                    {subtopic}
                                </h2>
                            </div>
                <div className="flex lg:w-1/2 w-full items-center justify-end gap-4">
                                <ThemeChanger />
                                <button
                                    className="btn btn-outline btn-base"
                                    onClick={handleReturnToDashboard}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        className="w-5 h-5 mr-2"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M10 19l-7-7m0 0l7-7m-7 7h18"
                                        />
                                    </svg>
                                    Return to Dashboard
                                </button>
                            </div>
                        </div>

                        <div className="card bg-base-100 shadow-xl">
                            <div className="card-body">
                                <div className="alert alert-info mb-6">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        className="stroke-current shrink-0 w-6 h-6"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                    <span>
                                        Based on your self-assessment, questions
                                        will be generated.
                                    </span>
                                </div>

                                {/* Module Ratings */}
                                <div className="mb-6">
                                    <h3 className="font-medium text-lg mb-4">
                                        Rate your knowledge for each module:
                                    </h3>

                                    <div className="divide-y divide-base-300">
                                        {modules.map((module) => (
                                            <div
                                                key={module}
                                                className="py-4 flex justify-between items-center"
                                            >
                                                <span className="text-base font-medium">
                                                    {module}
                                                </span>
                                                <div className="flex items-center gap-1">
                                                    {[1, 2, 3, 4, 5].map(
                                                        (star) => (
                                                            <button
                                                                key={`${module}-${star}`}
                                                                type="button"
                                                                className="btn btn-ghost p-1"
                                                                onClick={() =>
                                                                    handleStarClick(
                                                                        module,
                                                                        star
                                                                    )
                                                                }
                                                            >
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 24 24"
                                                                    fill={
                                                                        ratings[
                                                                            module
                                                                        ] >=
                                                                        star
                                                                            ? 'currentColor'
                                                                            : 'none'
                                                                    }
                                                                    stroke="currentColor"
                                                                    className={`w-6 h-6 ${ratings[module] >= star ? 'text-warning' : 'text-gray-300'}`}
                                                                >
                                                                    <path
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                        strokeWidth={
                                                                            ratings[
                                                                                module
                                                                            ] >=
                                                                            star
                                                                                ? '0'
                                                                                : '1.5'
                                                                        }
                                                                        d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
                                                                    />
                                                                </svg>
                                                            </button>
                                                        )
                                                    )}
                                                    <span className="ml-2 w-8 text-sm">
                                                        {ratings[module]
                                                            ? `${ratings[module]}/5`
                                                            : ''}
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Start Quiz Button */}
                                <div className="card-actions justify-end mt-4">
                                    <button
                                        className="btn btn-primary btn-lg"
                                        onClick={handleStartQuiz}
                                        disabled={!allModulesRated}
                                    >
                                        Start Quiz
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
